/**
 * API base URL. Use REACT_APP_API in .env (e.g. REACT_APP_API=http://localhost:5000).
 * Falls back to current origin when unset so requests don't get /undefined/ in the path.
 */
export const API_BASE =
  process.env.REACT_APP_API != null && process.env.REACT_APP_API !== ""
    ? process.env.REACT_APP_API.replace(/\/$/, "")
    : (typeof window !== "undefined" ? window.location.origin : "");
